// Remote API
const configuredApiUrl = 'https://roombooking-api.objective-faraday.119-59-118-127.plesk.page/api/';

// const configuredApiUrl = 'https://localhost:44303/api/';

const environment = {
    apiUrl: configuredApiUrl.endsWith('/') ? configuredApiUrl : `${configuredApiUrl}/`,
}
export default environment
